export enum TagOperation {
    None,
    Centroid,
    Vertex,
}
